import { render, staticRenderFns } from "./OBCard.vue?vue&type=template&id=e95e9146&"
import script from "./OBCard.vue?vue&type=script&lang=js&"
export * from "./OBCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports